











































import { defineComponent, PropType, ref } from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccTag from "@/components/Atoms/OccTag/index.vue";

export type Content<Key = string, SubKey = string> = {
  key: Key;
  name: string;
  errorCount?: number;
  subContents: {
    key: SubKey;
    name: string;
    invalid?: boolean;
    disabled?: boolean;
    hidden?: boolean;
    unClickable?: boolean;
  }[];
};

export type Props<Key = string> = {
  defaultOpenContentKey: Key;
  contents: Content[];
};

export default defineComponent({
  components: {
    OccHeading,
    OccTag
  },
  name: "TableOfContents",
  props: {
    defaultOpenContentKey: {
      type: String as PropType<Props["defaultOpenContentKey"]>,
      required: false
    },
    contents: {
      type: Array as PropType<Props["contents"]>,
      required: true
    }
  },
  emits: ["clickContent", "clickSubContent"],
  setup(props, { emit }) {
    const selectedContentKeys = ref<string[]>([
      props.defaultOpenContentKey || props.contents[0]?.key
    ]);

    const onClickContent = (contentKey: string) => {
      if (selectedContentKeys.value.includes(contentKey)) {
        selectedContentKeys.value = selectedContentKeys.value.filter(
          key => key !== contentKey
        );
      } else {
        selectedContentKeys.value = [...selectedContentKeys.value, contentKey];
      }
      emit("clickContent", contentKey);
    };

    const onClickSubContent = (contentKey: string, subContentKey: string) => {
      emit("clickSubContent", [contentKey, subContentKey]);
    };

    const exclusionHiddenSubContents = (
      subContents: Content["subContents"]
    ) => {
      return subContents.filter(subContent => !subContent.hidden);
    };

    return {
      selectedContentKeys,
      onClickContent,
      onClickSubContent,
      exclusionHiddenSubContents
    };
  }
});
